import { Button, Form, Space, Typography } from 'antd';

import { Phone } from '@app/components';
import { OFF } from '@app/constants';
import { PREFIX } from '@app/constants/appPrefix';
import type { NUserProfile } from '@app/pages/Users/UserProfile/UserProfile.types';

const { Text } = Typography;
const { Item } = Form;

export const PhoneInfo: NUserProfile.PhoneInfo = ({
  updatePhoneNumber,
  telForm,
  setPhoneValidation,
  currentPhoneNumber,
}) => (
  <div className={`${PREFIX}phone-info`}>
    <Form
      form={telForm}
      onFinish={updatePhoneNumber}
      className="bc-form full-width"
      autoComplete={OFF}
    >
      <Space direction="vertical" size="middle" className="form-space">
        <div className="container">
          <Typography.Text strong data-testid="current-mobile">
            Текущий номер
          </Typography.Text>

          <Form.Item className="mg-0">
            <Typography.Title level={5} data-testid="current-mobile-value">
              +{currentPhoneNumber}
            </Typography.Title>
          </Form.Item>
        </div>
        <div className="container ai-unset">
          <div className="new-phone-container">
            <Text className={'label-require'}>Мобильный телефон</Text>
            <Item name="Phone" className="max-width-400">
              <Phone name="Phone" required onValidate={setPhoneValidation} />
            </Item>
          </div>
        </div>

        <Button
          type="primary"
          htmlType="submit"
          className="save-button"
          data-testid="save-mobile"
        >
          Сохранить
        </Button>
      </Space>
    </Form>
  </div>
);
